<template>
  <div class="grid-x grid-margin-x align-center">
    <table
      aria-label="promo chart"
      class="table"
      :style="{ '--border-color': promoChart?.attributes?.borderColor || '#FFFFFF' }"
    >
      <thead
        class="custom-bottom-border-3 grid-x align-justify"
        :class="headerClass"
        :style="{ color: headerColor }"
      >
        <tr
          role="row"
          tabindex="-1"
          class="grid-x padding-bottom-xxs"
        >
          <th
            :id="'header-' + 0"
            scope="col"
            class="table-header cell small-6 text-left"
            role="columnheader"
          >
            {{ promoChart?.headers?.values?.column1Title }}
          </th>
          <th
            :id="'header-' + 1"
            scope="col"
            class="table-header cell small-6 text-right"
            role="columnheader"
          >
            {{ promoChart?.headers?.values?.column2Title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, index) in promoChart?.rows?.values"
          :key="index"
          class="grid-x align-justify custom-bottom-border-3 padding-top-xxs padding-bottom-xxs"
          :class="rowClass"
          :style="{ color: rowColor }"
          role="row"
          tabindex="-1"
        >
          <td
            class="table-cell margin-right-m"
            role="cell"
            :aria-labelledby="'header-' + 0"
          >
            {{ row?.column1Value }}
          </td>
          <td
            class="table-cell"
            role="cell"
            :aria-labelledby="'header-' + 1"
          >
            {{ row?.column2Value }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  promoChart: {
    type: Object,
    default: () => ({
      rows: { values: [] },
    }),
  },
});

const rowClass = ref(props.promoChart.rows?.attributes?.rowStyleClass || 'avant-garde-demi-h5');
const headerClass = ref(props.promoChart.headers?.attributes?.headerStyleClass || 'avant-garde-demi-h6');
const rowColor = ref(props.promoChart.rows?.attributes?.rowsColor || '#FFFFFF');
const headerColor = ref(props.promoChart.headers?.attributes?.titleColor || '#FFFFFF');

</script>
<style lang="scss" scoped>
@import './../../scss/globalAttributes.bcom.scss';

.table {
  @include breakpoint(medium) {
    padding: 0 rem-calc(28px);
  }

  &.text-ad-chart {
    @include breakpoint(mlarge) {
      padding: 0 rem-calc(56px);
    }
  }
}

.table,
tr {
  width: rem-calc(262px);
  flex-wrap: nowrap;
}

tbody tr:last-of-type {
  padding-bottom: 0 !important;
}

th {
  font-weight: inherit;

  &:first-of-type {
    padding-right: rem-calc(4px);
  }
  &:last-of-type {
    padding-left: rem-calc(4px);
  }
}

.table-header {
  text-transform: uppercase;
  color: inherit;
}

.custom-bottom-border-3 {
  border-bottom: 1px solid var(--border-color);
  &:last-child {
    border-bottom: none;
  }
}
</style>
